import { observable, action } from 'mobx';

import { Variables, ConnectionAppManager, AppRegistry } from 'core';

import { SharedFileArrayApp } from 'apps/share/app';
import { ProfileSharedFilesQuery } from 'apps/share/gql';

export class SharedFileConnManager extends ConnectionAppManager {
  static ArrayApp = SharedFileArrayApp;
  @observable sortBy;

  constructor(parent, init) {
    super(parent, init);
    this.initialBatchSize =
      init.initialBatchSize || this.arrayApp.cardLayout.initialBatchSize;
    this.batchSize = init.batchSize || this.arrayApp.cardLayout.batchSize;
    this.sortBy = init.sortBy || 'recent';
    this.variables = new Variables({
      sortBy: () => this.sortBy,
      batchSize: () =>
        this.loadedMore ? this.batchSize : this.initialBatchSize,
      cursor: () => this.endCursor,
    });
    this.loadMoreQuery = init.loadMoreQuery || ProfileSharedFilesQuery;
  }

  @action SetSort(sort) {
    this.sortBy = sort;
    this.Clear();
    this.loadMore();
  }
}
AppRegistry.add(SharedFileConnManager);
